import { PdResizeContent } from "./pd-resize-content/PdResizeContent.js";
//#region src/pd-resize-content/pd-resize-content.ts
var tag = "pd-resize-content";
if (!customElements.get(tag)) customElements.define(tag, PdResizeContent);
//#endregion
export { PdResizeContent };
